import { emitDashboardDiagnostic } from '../observability/dashboardRuntimeDiagnostics';

function reportRuntimeError(
  type: 'window_error' | 'unhandled_rejection',
  payload: Record<string, unknown>,
) {
  emitDashboardDiagnostic(type, 'error', payload);
}

export function registerRuntimeErrorHandlers() {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('error', (event) => {
    reportRuntimeError('window_error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const rejection = event.reason;
    reportRuntimeError('unhandled_rejection', {
      rejection_message:
        rejection instanceof Error ? rejection.message : String(rejection),
      rejection_name: rejection instanceof Error ? rejection.name : undefined,
      rejection_type: typeof rejection,
    });
  });
}
